import React, { useState } from 'react'
import { theme } from 'twin.macro'

import { TypeTwoCardContainer } from './styles'
import ArrowOrange from '../../../Blocks/Buttons/arrowOrange'

const TypeTwoCard = () => {
  const [hovering, setHovering] = useState(false)
  return(
    <TypeTwoCardContainer href="https://www.type2congress.com/Type2virtualbooth_dd300225-7226-4922-ac22-eccabc017714" target="_blank" rel="noreferrer" onMouseEnter={() => setHovering(true)} onMouseLeave={() =>setHovering(false)}>
      <p className="typetwocard-title">Experience the Type 2 Inflammation Virtual Booth</p>
      <ArrowOrange hovering={hovering} textColor={theme`colors.white`} hoverColor={theme`colors.royalblue`} />
    </TypeTwoCardContainer>
  )
}

export default TypeTwoCard